import ResendPhoneTokenError from './ResendPhoneTokenError';
class CannotResendPhoneToken extends ResendPhoneTokenError {
    constructor(options) {
        super('Can not resend phone token', options);
    }
}
export default CannotResendPhoneToken;
